import _taggedTemplateLiteral from "/home/jenkins/workspace/terra.b2c.webui.register_staging/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { Text } from '../../../Atoms';
export var StyledCardSubTitle = styled(Text)(_templateObject(), function () {
  return "\n        margin-top: 0;\n        margin-bottom: 0;\n    ";
});